<template>
  <tr>
    <td class="time-col">
      <abbr class=timeago :title="created_at">{{ymd}}</abbr>
    </td>
    <td class="email-col">
      <a :href="requery(email)">{{email}}</a>
    </td>
    <td class="org-col">
      <a :href="requery(organization)">{{organization}}</a>
    </td>
    <td class="action-col">
      <a :href="requery(request.replace('#',' '))">{{request}}</a>
    </td>
    <td class = "link-col">
      <span v-if="request_url">
        <a target="_blank" :title="request_url" :href="request_url">
          <i class="material-icons">&#xE89E;</i>
        </a>
        <a :href="requery(request_url)">
          <i class="material-icons">find_in_page</i>
        </a>
      </span>
    </td>
    <td class = "details-col">
      <a :href="activity.url"><i class='material-icons'>pageview</i></a>
    </td>
  </tr>
</template>

<script>
import {get} from 'lodash'
import URI from "urijs"

export default {
  props: ['activity'],
  computed: {
    created_at() {
      return this.activity.created_at
    },
    ymd() {
      return this.activity.created_at.slice(0,10)
    },
    email() {
      return get(this.activity, "data.user.email")
    },
    organization() {
      return get(this.activity, "data.organization.name")
    },
    request() {
      return `${get(this.activity, "data.request.controller_name")}#${get(this.activity, "data.request.action_name")}`
    },
    request_url() {
      return get(this.activity, "data.request.url")
    },
  },
  methods: {
    requery(q){
      var uri = URI(document.location.toString())
      return uri.setSearch("q", q).toString()
    }
  },
  mounted() {
    $(this.$el).find("abbr.timeago").timeago()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// activity_row.vue?d5370c58